export default __webpack_public_path__ + "static/media/blossom.c11c7ef7.svg";